module.exports = __webpack_public_path__ + "img/ai-tutor.1f6a9073.svg";